module.exports = __webpack_public_path__ + "static/media/dark_view.a1a0ba61.svg";